import {
  CancellationRequest,
  Client,
  Contact,
} from '@lockton-apps/shared/interfaces';
import { createAction, props } from '@ngrx/store';

export enum FormDialogActionTypes {
  ClientUpdated = '[Client Form Dialog] Client Updated',
  ContactUpdated = '[Contact Form Dialog] Contact Updated',
  ClientAndContactUpdated = '[Contact Form Dialog] Client And Contact Updated',
  PolicyCancellationRequested = '[PolicyCancellation Dialog] Cancellation Requested',
}

export const FormDialiogActions = {
  clientUpdated: createAction(
    FormDialogActionTypes.ClientUpdated,
    props<{ client: Client }>()
  ),
  contactUpdated: createAction(
    FormDialogActionTypes.ContactUpdated,
    props<{ contact: Contact }>()
  ),
  clientAndContactUpdated: createAction(
    FormDialogActionTypes.ClientAndContactUpdated,
    props<{ client: Client; contact: Contact }>()
  ),
  policyCancellationRequested: createAction(
    FormDialogActionTypes.PolicyCancellationRequested,
    props<{ cancellationRequest: CancellationRequest }>()
  ),
};
